import React from "react";

const Privacy = () => {
  return (
    <div className="privacyPolicy">
      <h1>Privacy Policy</h1>
      <p>
        This privacy policy has been compiled to better serve those who are
        concerned with how their 'Personally identifiable information' (PII) is
        being used online. PII, as used in NZ privacy law and information
        security, is information that can be used on its own or with other
        information to identify, contact, or locate a single person, or to
        identify an individual in context. Please read our privacy policy
        carefully to get a clear understanding of how we collect, use, protect
        or otherwise handle your Personally Identifiable Information in
        accordance with our website.
      </p>
      <h3>
        What personal information do we collect from the people that visit our
        blog, website or app?
      </h3>
      <p>
        When ordering or registering on our site, as appropriate, you may be
        asked to enter your Name, Email address, Phone number or other details
        to help you with your experience.
      </p>
      <h3>When do we collect information?</h3>
      <p>
        We collect information from you when you register on our site, subscribe
        to a newsletter, fill out a form or enter information on our site.
      </p>
      <h3>How do we use your information?</h3>
      <p>
        We may use the information we collect from you when you register, make a
        purchase, sign up for our newsletter, respond to a survey or marketing
        communication, surf the website, or use certain other site features in
        the following ways:
        <ul>
          <li>
            To personalize user's experience and to allow us to deliver the type
            of content and product offerings in which you are most interested.
          </li>
          <li>To improve our website in order to better serve you.</li>
          <li>
            To allow us to better service you in responding to your customer
            service requests.
          </li>
          <li>
            To administer a contest, promotion, survey or other site feature.
          </li>
          <li>To quickly process your transactions.</li>
          <li>
            To send periodic emails regarding your order or other products and
            services.
          </li>
        </ul>
      </p>
      <h3>How do we protect visitor information?</h3>
      <p>
        We use vulnerability scanning and/or scanning to PCI standards. We use
        an SSL certificate.
      </p>
      <h3>Do we use 'cookies'?</h3>
      <p>
        Yes. Cookies are small files that a site or its service provider
        transfers to your computer's hard drive through your Web browser (if you
        allow) that enables the site's or service provider's systems to
        recognize your browser and capture and remember certain information. For
        instance, we use cookies to help us remember and process the items in
        your shopping cart. They are also used to help us understand your
        preferences based on previous or current site activity, which enables us
        to provide you with improved services. We also use cookies to help us
        compile aggregate data about site traffic and site interaction so that
        we can offer better site experiences and tools in the future.We use
        cookies to compile aggregate data about site traffic and site
        interactions in order to offer better site experiences and tools in the
        future. We may also use trusted third party services that track this
        information on our behalf.
      </p>
      <p>
        You can choose to have your computer warn you each time a cookie is
        being sent, or you can choose to turn off all cookies. You do this
        through your browser settings. Each browser is a little different, so
        look at your browser's Help menu to learn the correct way to modify your
        cookies. If you disable cookies off, some features maybe disabled and
        some of our services may not function properly.
      </p>
      <h3>Third Party Disclosure</h3>
      <p>
        No, we do not sell, trade, or otherwise transfer to outside parties your
        personally identifiable information unless we provide you with advance
        notice. This does not include website hosting partners and other parties
        who assist us in operating our website, conducting our business, or
        servicing you, so long as those parties agree to keep this information
        confidential. We may also release your information when we believe
        release is appropriate to comply with the law, enforce our site
        policies, or protect ours or others' rights, property, or safety.
        However, non-personally identifiable visitor information may be provided
        to other parties for marketing, advertising, or other uses. personally
        identifiable information. We may also release your information when we
        believe release is appropriate to comply with the law, enforce our site
        policies, or protect ours or others' rights, property, or safety.
      </p>
      <h3>Third party links</h3>
      <p>
        Occasionally, at our discretion, we may include or offer third party
        products or services on our website. These third party sites have
        separate and independent privacy policies. We therefore have no
        responsibility or liability for the content and activities of these
        linked sites. Nonetheless, we seek to protect the integrity of our site
        and welcome any feedback about these sites.
      </p>
      <h3>Google</h3>
      <p>
        Google's advertising requirements can be summed up by Google's
        Advertising Principles. They are put in place to provide a positive
        experience for users.{" "}
        <a
          href="https://support.google.com/adwordspolicy/answer/1316548?hl=en"
          target="_blank"
          rel="noreferrer"
        >
          Read these here.
        </a>
      </p>
      <p>
        We have not enabled Google AdSense on our site but we may do so in the
        future.
      </p>
      <h3>Policy Updates</h3>
      <p>
        Users will be notified of any privacy policy changes on our Privacy
        Policy Page. Users are able to change their personal information by
        emailing us.
      </p>
      <h3>How does our site handle do not track signals?</h3>
      <p>
        We honour do not track signals and do not track, plant cookies, or use
        advertising when a Do Not Track (DNT) browser mechanism is in place.
      </p>
      <h3>COPPA (Children Online Privacy Protection Act)</h3>
      <p>
        When it comes to the collection of personal information from children
        under 13, the Children's Online Privacy Protection Act (COPPA) puts
        parents in control. The Federal Trade Commission, the nation's consumer
        protection agency, enforces the COPPA Rule, which spells out what
        operators of websites and online services must do to protect children's
        privacy and safety online. We do not specifically market to children
        under 13.
      </p>
      <h3>Fair Information Practices</h3>
      <p>
        In order to be in line with Fair Information Practices we will take the
        following responsive action, should a data breach occur: We will notify
        the users via email within 7 business days. We also agree to the
        individual redress principle, which requires that individuals have a
        right to pursue legally enforceable rights against data collectors and
        processors who fail to adhere to the law. This principle requires not
        only that individuals have enforceable rights against data users, but
        also that individuals have recourse to courts or a government agency to
        investigate and/or prosecute non-compliance by data processors.
      </p>
      <h3>Contacting Us</h3>
      <p>
        If there are any questions regarding this privacy policy you may enquire
        via the <a href="/contact/">contact page.</a>
      </p>
      <p>Last Edited on 21.04.2023</p>
    </div>
  );
};

export default Privacy;
